document.querySelectorAll('#menu-principal .dropdown').forEach((dropdown) => {
    const dropdownLink = dropdown.querySelector('.nav-link');
    const dropdownMenu = dropdown.querySelector('.dropdown-menu');
    dropdown.addEventListener('mouseenter', () => {
        // dropdownLink.classList.add('text-primary');
        dropdownLink.classList.add('text-dark');
        dropdownMenu.classList.add('show');
        dropdownMenu.style.top = dropdownLink.clientHeight + 'px';
        if (dropdownMenu.classList.contains('dropdown-menu-end')) {
            dropdownMenu.style.right = '0px';
        }
    });
    dropdown.addEventListener('mouseleave', () => {
        // dropdownLink.classList.remove('text-primary');
        dropdownLink.classList.remove('text-dark');
        dropdownMenu.classList.remove('show');
    });
});
